import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Markdown from '@/components/markdown';
import { HelperCore } from '@/common/dependencies';
import { Segmented, Skeleton } from 'antd';
import { KNOWLEDGE_REFERER } from '../input-file/shared';
import { useMcpItemContext } from '../chat-history/context';
import Tooltip from '@/ui/tooltip';
import { SVGPureIcon } from '@/ui';
import { request } from '@/common';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import QrcodeShare from '../qrcode-share';
import fullScreenModalStore from '../full-screen-modal/store';

const CardText = observer((props) => {
  const {
    data,
    event,
    cid,
    hasToolBar,
    isStaticCard,
  } = props;

  const {
    title,
    url,
    share_url: shareUrl,
    status,
  } = event;
  const fileName = title || `${+new Date}.md`;

  const [text, setText] = useState('');
  const [autoScroll, setAutoScroll] = useState(true);
  const refTextScroll = useRef(null);

  const downloadFile = async (url) => {
    if (/^https/.test(url)) {
      let _fileName = fileName;
      // 如果fileName没有文件后缀，则从url里取
      if (!/(\.[a-z]{1,4})(?:$|\?)/gi.test(_fileName) && /(\.[a-z]{1,4})(?:$|\?)/gi.test(url)) {
        _fileName = fileName + RegExp.$1;
      }
      if (/qiniu/.test(url)) {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        if (!params.get('attname')) {
          params.set('attname', encodeURIComponent(_fileName))
        }
        HelperCore.saveFile(urlObj.href, _fileName)
      }
      else if (/xstore/.test(url)) {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        if (!params.get('response-content-disposition')) {
          params.set('response-content-disposition', 'attname');
          params.set('filename', encodeURIComponent(_fileName))
        }
        HelperCore.saveFile(urlObj.href, _fileName)
      }
      else {
        if(HelperCore.isWeixin()){
          HelperCore.saveFile(url, _fileName);
        }else{
          const blob = await fetch(url).then(res => res.blob()).catch(err => null);
          if (blob) {
            const url = URL.createObjectURL(blob);
            HelperCore.saveFile(url, _fileName);
            URL.revokeObjectURL(url);
          }
        }
      }
    }
  }

  useEffect(() => {
    if (!data && /^http/i.test(url)) {
      setText('');
      fetch(url)
        .then(res => res.text())
        .then((res) => {
          setText(res);
        })
        .catch(() => {
          setText(`读取 ${data} 内容失败`);
        });
    } 
    else if(typeof event.content == "string"){
      setText(event.content);
    }
    else if(typeof data == "string"){
      setText(data);
    }

    if (autoScroll) {
      const el = refTextScroll?.current;
      el?.scrollTo({
        left: 0,
        top: el.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [data, url, event.content]);
  
  const mouseenter = () => {
    setAutoScroll(false)
  }

  const mouseleave = () => {
    setAutoScroll(true)
  }
    
  useEffect(() => {
    const el = refTextScroll?.current;
    el?.addEventListener('mouseenter', mouseenter);
    el?.addEventListener('mouseleave', mouseleave);

    return () => {
      el?.removeEventListener('mouseenter', mouseenter);
      el?.removeEventListener('mouseleave', mouseleave);
    }
  }, []);

  const {
    isAITyping,
  } = useMcpItemContext();

  return (
    <>
    {
      <header className={`pt-16px pb-8px px-24px tabs flex justify-left items-center ${hasToolBar ? 'absolute right-0 top-5px z-1' : ''}`}>
        {/* <Segmented
          value='结果'
          // onChange={onTabChange}
          options={['结果']}
        /> */}

        <div className="flex flex-grow"></div>

        {
          status === 'success' ? (
            <div 
              className={`
                h-28px box-border rounded-6px border-1px border-black
                border-opacity-16 leading-26px px-10px cursor-pointer
                hover:bg-[rgba(0,0,0,0.03)] mr-8px text-14px text-black
                flex items-center
                ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
              `}
              onClick={() => {
                if(isStaticCard){
                  // window.parent.postMessage({

                  // }, "*");
                  window.parent.fullScreenModalStore.setData({
                    show: true, 
                    type: "markdown",
                    data: {
                      shareUrl,
                      url,
                      content: text,
                      fileName,
                    }
                  });
                  return;
                }

                fullScreenModalStore.setData({
                  show: true, 
                  type: "markdown",
                  data: {
                    shareUrl,
                    url,
                    content: text,
                    fileName,
                  }
                });
              }}
            >
              <SVGPureIcon
                name="full_screen_modal_full2"
                className={`size-16px ${!HelperCore.isPhone() ? "mr-6px" : ""}`}
              />
              {
                !HelperCore.isPhone()
                ? "全屏"
                : null
              }
            </div>
          ) : null
        }

        {
          shareUrl
          ? (
            <Tooltip 
              title={
                HelperCore.isPhone()
                ? null
                : <QrcodeShare url={shareUrl} />
              } 
              color="white"
              placement="bottomLeft"
              arrow={false}
              getPopupContainer={node => node}
              destroyTooltipOnHide
            >
              <div 
                className={`
                  h-28px box-border rounded-6px border-1px border-black
                  border-opacity-16 leading-26px px-10px cursor-pointer
                  hover:bg-[rgba(0,0,0,0.03)] mr-8px text-14px text-black card-share-btn
                  flex items-center
                  ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
                `}
                onClick={() => {
                  const copied = copy(shareUrl);
                  copied && Other.toast('复制成功', "success");
                }}
              >
                <SVGPureIcon
                  name="full_screen_modal_share2"
                  className={`size-16px ${!HelperCore.isPhone() ? "mr-6px" : ""}`}
                />
                {
                  !HelperCore.isPhone()
                  ? "分享"
                  : null
                }
              </div>
            </Tooltip>
          )
          : null
        }
        {
          url ? (
            <Tooltip destroyTooltipOnHide>
              <div
                className={`
                  h-28px box-border rounded-6px border-1px border-black
                  border-opacity-16 leading-26px px-10px cursor-pointer
                  hover:bg-[rgba(0,0,0,0.03)] text-14px text-black
                  flex items-center
                  ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
                `}
                onClick={e => {
                  downloadFile()
                }}
              >
                <SVGPureIcon
                  name="download"
                  className="size-18px cursor-pointer "
                />
                {
                  !HelperCore.isPhone()
                  ? "下载"
                  : null
                }
              </div>
            </Tooltip>
          ) : null
        }
      </header>
    }
    <div
      className="card-text px-24px my-16px overflow-x-hidden overflow-y-auto scrollbar"
      ref={refTextScroll}
    >
      {isAITyping && !text && (!event?.status || event?.status == "running") ? (
        <Skeleton className="" active />
      ) : (
        <Markdown
          typing={false}
          text={text}
          className="!text-14px !leading-22px"
          components={{
            a: ({ href, children, ...props }) => {
              const ext = HelperCore.getFileNameExt(href).toLowerCase();
              const config = KNOWLEDGE_REFERER[ext];

              if (
                config &&
                ((typeof children == 'string' && /\d/.test(children)) ||
                  (Array.isArray(children) &&
                    children.length == 1 &&
                    typeof children[0] == 'string' &&
                    /\d/.test(children[0])))
              ) {
                return (
                  <a
                    className={`!border-1px !border-solid rounded-full px-4px py-2px mx-8px relative -top-1px whitespace-nowrap inline-block text-12px font-bold-600 w-max select-none transform scale-90 origin-center`}
                    style={{
                      color: config.color,
                      borderColor: config.color,
                    }}
                    target="_blank"
                    href={href}
                  >
                    {children}
                    <span
                      className="opacity-30 mx-2px w-1px h-8px inline-block"
                      style={{
                        background: config.color,
                      }}
                    ></span>
                    {config.text}
                  </a>
                );
              }

              return (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...props}
                >
                  {children}
                </a>
              );
            },
          }}
        />
      )}
    </div>
    </>
  );
});

export default CardText;
